
import React from 'react'
import { EMPTY_OBJECT, PROJECTS, PROFESSIONALS, PRODUCTS, IMAGES } from '../../utils/constants'
import Icon from '../../components/ui/icon/Icon'
import {
  AREA,
  AREA_FILTERS,
  CATEGORIES_TREE_FILTERS,
  CATEGORIES_LEVEL_FILTERS,
  CATEGORIES,
  FILTERS_CATEGORIES_ARRAY,
  KEYS_CAT_LEVEL_ONE,
  FILTERS_CATEGORIES_KEYS,
  ACTIVITY_COUNTRY,
  PROJECT_CATEGORY,
  PROJECTS_AREA,
  PROJECTS_CATEGORY,
  COUNTRY,
  CATEGORIES_TYPES,
  EXPERTISE_TYPES,
  CATEGORIES_TREE_TYPES,
  CATEGORIES_LEVEL_TYPES
} from './constants'

/**
 * Get active previous categories level labels
 * @param   {string} item - type of category level
 * @param   {string} type - view's type
 * @param   {object} data - active filters object
 * @param   {string} joinCategoriesLabels - string to know if we have to join first and second categories label
 * @param   {object} categories - active categories levels object
 *
 * @returns {array} an object of active categories levels with the previous category level label
 */
export const getPreviousActiveCategory = (item = '', type, data, joinCategoriesLabels, categories = EMPTY_OBJECT) => {
  if (item && data.hasOwnProperty(item) && data[item].length > 0) {
    const catOneKey = `${FILTERS_CATEGORIES_KEYS[type]}_1`
    const catTwoKey = `${FILTERS_CATEGORIES_KEYS[type]}_2`
    const splittedCat = item.split('_')
    if (KEYS_CAT_LEVEL_ONE.includes(item) && Object.keys(categories).length > 1 && joinCategoriesLabels) {
      // eslint-disable-next-line max-len
      const catOneLabel = ((data.hasOwnProperty(catOneKey) && data[catOneKey].filter(a => (a.slug || a.name) === categories[catOneKey])[0]) || EMPTY_OBJECT).name
      const catTwoLabel = data.hasOwnProperty(catTwoKey)
        ? (data[catTwoKey].filter(a => (a.slug || a.name) === categories[catTwoKey])[0] || EMPTY_OBJECT).name
        : ''
      return (
        <>
          {catOneLabel}
          <Icon svg='longRigthArrow' />
          {catTwoLabel}
        </>
      )
    } else {
      const category = KEYS_CAT_LEVEL_ONE.includes(item) ? catOneKey : `${splittedCat[0]}_${Number(splittedCat[1]) - 1}`
      return categories[category]
        ? (data[category].filter(a => (a.slug || a.name) === categories[category])[0] || EMPTY_OBJECT).name
        : ''
    }
  }
  return ''
}

/**
 * Get all categories level labels
 * @param   {object} data - active filters object
 * @param   {string} type - view's type
 * @param   {object} activeCategories - active categories levels object
 * @param   {string} joinCategoriesLabels - string to know if we have to join first and second categories label
 *
 * @returns {object} an object with the active categories and their labels
 */
export const getCatLabels = (data = EMPTY_OBJECT, type, activeCategories, joinCategoriesLabels) => {
  const catLabels = FILTERS_CATEGORIES_ARRAY.hasOwnProperty(type) && FILTERS_CATEGORIES_ARRAY[type].reduce((acc, curr, idx) => {
    const categoryKey = `${FILTERS_CATEGORIES_KEYS[type]}_${idx + 1}`
    const categoryHasLabel = data && data.hasOwnProperty(categoryKey)
      ? getPreviousActiveCategory(categoryKey, type, data, joinCategoriesLabels, activeCategories)
      : null
    if (categoryHasLabel) {
      acc[categoryKey] = categoryHasLabel
    }
    return acc
  }, {})
  return catLabels || EMPTY_OBJECT
}

/**
 * Check if min_area/max_area filter keys are active in the filters active object and creates an array
 * @param   {object} obj - filters active object
 *
 * @returns {array}  returns an array with area filters active items
 */
export const getAreaSelected = (obj = EMPTY_OBJECT) => AREA_FILTERS.filter(areaFilter => obj.hasOwnProperty([areaFilter]))

/**
 * Check if the filter is Categories and is able to handle level categories
 * @param   {string} item - filter's name
 * @param   {string} type - view's type
 *
 * @returns {boolean} returns true if filter for the receive type has to render a categories tree
 */
export const isCategoriesWithLevelsFilter = (item, type) => (
  CATEGORIES_LEVEL_TYPES.includes(type) && CATEGORIES_LEVEL_FILTERS.includes(item)
)

/**
 * Check if the filter is Categories and type of search is Projects
 * @param   {string} item - filter's name
 * @param   {string} type - view's type
 *
 * @returns {boolean} returns true if filter is CATEGORIES and type is PROJECTS
 */
export const isProjectsCategories = (item, type) => type === PROJECTS && item === CATEGORIES

/**
 * Check if the filter should use the categories tree data
 * @param   {string} item - filter's name
 * @param   {string} type - view's type
 *
 * @returns {boolean} returns true if filter should use the categories tree data
 */
export const isCategoriesTreeFilter = (item, type) => {
  return CATEGORIES_TREE_TYPES.includes(type) && CATEGORIES_TREE_FILTERS.includes(item)
}

export const getFilterLabel = (item, searchType) => {
  let labelKey = item
  switch (item) {
    case CATEGORIES:
      if (searchType === PROFESSIONALS) {
        labelKey = PROJECTS_CATEGORY
      } else if (searchType === IMAGES) {
        labelKey = PROJECT_CATEGORY
      }
      break
    case COUNTRY:
      if (searchType === PROFESSIONALS) {
        labelKey = ACTIVITY_COUNTRY
      }
      break
    case AREA:
      if (searchType === PROFESSIONALS) {
        labelKey = PROJECTS_AREA
      }
      break
    default:
      labelKey = item
  }
  return labelKey
}

export const getCategoryItem = (item, searchType) => {
  switch (searchType) {
    case PRODUCTS:
      return CATEGORIES_TYPES.includes(item)
    case PROFESSIONALS:
      return EXPERTISE_TYPES.includes(item)
    default:
      return false
  }
}

export const meterToFeet = num => Math.round((num * 10.7639))

export const feetToMeter = num => Math.round((num * 0.092903))